import type { ExitCriteriaReport } from '@testflow/shared';
import { pickLang } from '../../lib/pick-lang.js';

export function ExitCriteriaList({ data, lang }: { data: ExitCriteriaReport; lang: string }) {
  return (
    <ul className="space-y-1.5">
      {data.criteria.map((c) => (
        <li
          key={c.key}
          data-testid={`crit-${c.key}`}
          data-met={c.met}
          className="flex items-center justify-between text-sm"
        >
          <span className="flex items-center gap-2">
            <span className={c.met ? 'text-status-pass' : 'text-status-warn'}>
              {c.met ? '✓' : '!'}
            </span>
            <span className="text-text-body">{pickLang(lang, c.label_de, c.label_en)}</span>
          </span>
          <span className="font-mono text-xs text-text-muted">
            {c.threshold !== null
              ? `${c.actual}% / ${c.threshold}%`
              : c.actual === 0
                ? 'OK'
                : String(c.actual)}
          </span>
        </li>
      ))}
    </ul>
  );
}
